



























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AccountEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stAccountApi, stRateRuleApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { notifySuccess, notifyWarning } from '@/utlitities/notifications';
import { AccountStore } from '@/store/account-module';
import StTabs from '@/components/tabs/StTabs.vue';
import { TabModel } from '@/components/tabs/tab-model';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';
import AccountSettingsPrivacy from '@/views/Settings/AccountSettingsPrivacy.vue';
import AccountSettingsDeleteAccount from '@/views/Settings/AccountSettingsDeleteAccount.vue';
import StBadge from '@/components/basic/StBadge.vue';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';
import AccountSettingsTimeTracking from '@/views/Settings/AccountSettingsTimeTracking.vue';

@Component({
  components: {
    AccountSettingsTimeTracking,
    StSettingsSeparator,
    StBadge,
    AccountSettingsDeleteAccount,
    AccountSettingsPrivacy,
    StTabs,
    AccountSettingsInvoice,
    StCurrencyInput,
  },
})
export default class AccountSettings extends Vue {
  saveLoading: boolean = false;
  loading: boolean = false;
  activeTabName = 'standard';
  accountEditModel: AccountEditModel = AccountEditModel.fromJS({});

  async mounted() {
    try {
      this.loading = true;
      await this.loadEditModel();
    } finally {
      this.loading = false;
    }
  }

  get tabs(): TabModel[] {
    let res = [
      {
        TabName: 'standard',
        Disabled: false,
      },
      {
        TabName: 'timeTracking',
        Disabled: false,
      },
      {
        TabName: 'invoice',
        Disabled: false,
      },
      {
        TabName: 'privacy',
        Disabled: false,
      },
      {
        TabName: 'termination',
        Disabled: false,
      },
    ];

    if (this.noOutgoingInvoices) {
      res.splice(2, 1);
    }

    return res;
  }

  get featureFlagFixedPriceProjects(){
    return UserStore.userSettings.featureFlagFixedPriceProjects;
  }

  get noRates() {
    return this.accountEditModel.noRates;
  }

  get useDisableVacationCarryover(): boolean {
    return UserStore.userSettings.featureFlagDisableVacationCarryOver;
  }

  get noOutgoingInvoices() {
    return this.accountEditModel.noOutgoingInvoices;
  }

  get currentUserRateRulesValue() {
    return UserStore.userSettings.useRateRules;
  }

  get useRates() {
    return !this.accountEditModel.noRates;
  }

  set useRates(data: boolean) {
    this.accountEditModel.noRates = !data;
  }

  get logo() {
    return AccountStore.logo;
  }

  get useProjectTimeTracking() {
    return !this.accountEditModel.useBasicTimeTracking;
  }

  set useProjectTimeTracking(data: boolean) {
    this.accountEditModel.useBasicTimeTracking = !data;
  }

  get wantsToUpgradeToProjectTimeTracking() {
    return (
      !UserStore.userSettings.paymentStatus.isInTrial &&
      UserStore.userSettings.paymentStatus.paymentIsSetup &&
      UserStore.userSettings.useBasicTimeTracking &&
      !this.accountEditModel.useBasicTimeTracking
    );
  }

  get useOutgoingInvoices() {
    return !this.accountEditModel.noOutgoingInvoices;
  }

  set useOutgoingInvoices(data: boolean) {
    this.accountEditModel.noOutgoingInvoices = !data;
  }

  async loadEditModel() {
    this.accountEditModel = await stAccountApi.get(UserStore.userSettings.accountId!);
  }

  @Watch('accountEditModel.useRateRules')
  useRateRulesChanged(newVal: boolean, oldVal: boolean) {
    if (!newVal && oldVal) {
      notifyWarning('Das Deaktivieren dieser Option löscht alle vorhandenen Stundensatzregeln.');
    }
  }

  async deleteLogo() {
    await stAccountApi.deleteLogo();
    await this.loadEditModel();
    await AccountStore.reloadStore();
  }

  openFileSelect() {
    (this.$refs.file as HTMLInputElement).click();
  }

  async upload() {
    //@ts-ignore
    if (!(this.$refs.file as HTMLInputElement).files[0]) {
      return;
    }
    //@ts-ignore
    const fileData = (this.$refs.file as HTMLInputElement).files[0] as any;
    await stAccountApi.uploadLogo({ data: fileData, fileName: fileData.name });
    await AccountStore.reloadStore();
    await this.loadEditModel();
  }

  async submit() {
    try {
      this.saveLoading = true;
      if (this.accountEditModel.noOutgoingInvoices) {
        this.accountEditModel.useEmailSending = false;
      }
      await stAccountApi.put(this.accountEditModel.id, this.accountEditModel);

      if (this.currentUserRateRulesValue && !this.accountEditModel.useRateRules) {
        await stRateRuleApi.deleteAll();
      }

      await UserStore.reloadStore();
      notifySuccess('Gespeichert');
    } finally {
      this.saveLoading = false;
    }
  }
}
